import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import AppContext from "../../context/AppContext";
import NotificationDropdown from "../../screens/customer/customernotifications/NotificationDropdown";
import "../../assets/css/customer/customernotifications/NotificationDropdown.css";
import "../../assets/css/layout/customer/CustomerHeader.css";

const CustomerHeader = ({
  pageTitle,
  breadcrumb,
  customerName,
  onToggleSidebar,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { baseUrl } = React.useContext(AppContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  /* ───────── GET NOTIFICATION COUNT ───────── */

 const getNotificationCount = () => {
  const escustomerId = localStorage.getItem("customerId");
  if (!escustomerId) return;

  axios
    .get(`${baseUrl}/customer/notifications/viewLatestNotifications`, {
      params: { escustomer_id: escustomerId },
    })
    .then((response) => {
      setNotificationCount(response.data.count);
    })
    .catch((error) => {
      console.log(error);
    });
};
  
  useEffect(() => {
    setShowDropdown(false);
  }, [location]);
  useEffect(() => {
    getNotificationCount();
  }, []);

  const initials = customerName
    ? customerName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "CU";

  return (
    <header className="sgc-header">
      {/* LEFT */}

      <div className="d-flex align-items-center gap-3">
        <div className="sgc-header-toggle" onClick={onToggleSidebar}>
          ☰
        </div>

        <div>
          <p className="sgc-header-page-title">{pageTitle || "Dashboard"}</p>

          {breadcrumb && <p className="sgc-header-breadcrumb">{breadcrumb}</p>}
        </div>
      </div>

      {/* RIGHT */}

      <div className="sgc-header-right">
        {/* Notifications */}

        <div className="sgc-header-notification-wrap">
          <div
            className="sgc-header-notification"
            onClick={() => setShowDropdown((prev) => !prev)}
          >
            🔔
            {notificationCount > 0 && (
              <span className="sgc-header-notification-badge">
                {notificationCount}
              </span>
            )}
          </div>

          {/* Dropdown */}

          {showDropdown && (
            <NotificationDropdown onClose={() => setShowDropdown(false)} />
          )}
        </div>

        {/* Profile */}

        <div
          className="sgc-header-user"
          onClick={() => navigate("/customer/profile")}
        >
          <div className="sgc-header-avatar">{initials}</div>

          <span>{customerName || "Customer"}</span>
        </div>
      </div>
    </header>
  );
};

export default CustomerHeader;
